import { OnInit } from '@angular/core';
import { DacConfig } from 'app/shared/services/dac-config.service';
var FooterComponent = /** @class */ (function () {
    function FooterComponent(dacConfig) {
        this.dacConfig = dacConfig;
        this.fixedBottom = false;
    }
    FooterComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(FooterComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "supportPhone", {
        get: function () {
            return this.dacConfig.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "copyrightTitle", {
        get: function () {
            return this.dacConfig.copyrightTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "mailLink", {
        get: function () {
            return "mailto:" + this.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "phoneLink", {
        get: function () {
            return "tel:" + this.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "copyrightURL", {
        get: function () {
            return this.dacConfig.copyrightURL;
        },
        enumerable: true,
        configurable: true
    });
    return FooterComponent;
}());
export { FooterComponent };



// WEBPACK FOOTER //
// ./src/app/theme/footer/footer.component.ts.pre-build-optimizer.js